 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"about":"about","agb":"agb","dynamic-price-admin-hotel~dynamic-price-hotel":"dynamic-price-admin-hotel~dynamic-price-hotel","dynamic-price-hotel":"dynamic-price-hotel","create-hotel~dynamic-price-admin-hotel~edit-hotel~minimum-stay-hotel~report":"create-hotel~dynamic-price-admin-hotel~edit-hotel~minimum-stay-hotel~report","dynamic-price-admin-hotel":"dynamic-price-admin-hotel","minimum-stay-hotel":"minimum-stay-hotel","manage-event":"manage-event","price-calculator-hotel":"price-calculator-hotel","edit-hotel":"edit-hotel","report":"report","hotel-staff":"hotel-staff","manage-message":"manage-message","manage-user":"manage-user","contact":"contact","create-hotel":"create-hotel","dashboard":"dashboard","facts":"facts","login":"login","press":"press","privacy":"privacy","test":"test","user-profile":"user-profile","apexcharts":"apexcharts"}[chunkId]||chunkId) + "." + {"about":"fe912752","agb":"08be808b","chunk-55a482a8":"4b1dff60","dynamic-price-admin-hotel~dynamic-price-hotel":"bc25847f","dynamic-price-hotel":"2ee9c0df","chunk-78d1a34d":"0aa36bc9","create-hotel~dynamic-price-admin-hotel~edit-hotel~minimum-stay-hotel~report":"a82811c7","dynamic-price-admin-hotel":"a419c4c5","minimum-stay-hotel":"94239c7e","manage-event":"c9fe1e9b","price-calculator-hotel":"5ee364bb","edit-hotel":"7f3650d3","report":"30b63fd9","hotel-staff":"23e982ee","manage-message":"910aa3f7","manage-user":"c9e07842","contact":"034989a5","create-hotel":"04240dd3","dashboard":"212f3004","facts":"1bc402d9","login":"30e0b7e8","press":"11ac5683","privacy":"e8a9063a","test":"8871c443","user-profile":"6e2d3826","chunk-9e3e834c":"8acec1a2","chunk-1e068ef0":"103ec5a5","chunk-595e8de4":"d3654ee4","chunk-785ca0dc":"8ad41765","chunk-f76831c2":"e47f8a13","chunk-2d0cf902":"2f5b9207","chunk-2530a241":"83046e07","chunk-2a82d251":"ad8e1cd3","chunk-5514ccb5":"2d18b89c","chunk-68a27c44":"9a793f81","chunk-7ff1819d":"a933c0f8","apexcharts":"b91fba9d","chunk-2d0b8e18":"0abeb09f","chunk-3daefc74":"5aa8e7b6","chunk-fcc1c934":"b139666f"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"agb":1,"chunk-55a482a8":1,"dynamic-price-admin-hotel~dynamic-price-hotel":1,"dynamic-price-hotel":1,"chunk-78d1a34d":1,"create-hotel~dynamic-price-admin-hotel~edit-hotel~minimum-stay-hotel~report":1,"dynamic-price-admin-hotel":1,"minimum-stay-hotel":1,"manage-event":1,"price-calculator-hotel":1,"edit-hotel":1,"report":1,"hotel-staff":1,"manage-message":1,"manage-user":1,"contact":1,"create-hotel":1,"dashboard":1,"facts":1,"login":1,"press":1,"privacy":1,"test":1,"user-profile":1,"chunk-9e3e834c":1,"chunk-1e068ef0":1,"chunk-595e8de4":1,"chunk-785ca0dc":1,"chunk-f76831c2":1,"chunk-2530a241":1,"chunk-2a82d251":1,"chunk-5514ccb5":1,"chunk-68a27c44":1,"chunk-7ff1819d":1,"chunk-3daefc74":1,"chunk-fcc1c934":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"about":"about","agb":"agb","dynamic-price-admin-hotel~dynamic-price-hotel":"dynamic-price-admin-hotel~dynamic-price-hotel","dynamic-price-hotel":"dynamic-price-hotel","create-hotel~dynamic-price-admin-hotel~edit-hotel~minimum-stay-hotel~report":"create-hotel~dynamic-price-admin-hotel~edit-hotel~minimum-stay-hotel~report","dynamic-price-admin-hotel":"dynamic-price-admin-hotel","minimum-stay-hotel":"minimum-stay-hotel","manage-event":"manage-event","price-calculator-hotel":"price-calculator-hotel","edit-hotel":"edit-hotel","report":"report","hotel-staff":"hotel-staff","manage-message":"manage-message","manage-user":"manage-user","contact":"contact","create-hotel":"create-hotel","dashboard":"dashboard","facts":"facts","login":"login","press":"press","privacy":"privacy","test":"test","user-profile":"user-profile","apexcharts":"apexcharts"}[chunkId]||chunkId) + "." + {"about":"31d6cfe0","agb":"bd82aa3d","chunk-55a482a8":"32f9c07b","dynamic-price-admin-hotel~dynamic-price-hotel":"fa34b6a7","dynamic-price-hotel":"e00923ee","chunk-78d1a34d":"755d69e2","create-hotel~dynamic-price-admin-hotel~edit-hotel~minimum-stay-hotel~report":"adc1f731","dynamic-price-admin-hotel":"97c37964","minimum-stay-hotel":"b0c30431","manage-event":"929b93ff","price-calculator-hotel":"49fbd005","edit-hotel":"57fc9ab7","report":"d9a52c93","hotel-staff":"23df841b","manage-message":"f5313c19","manage-user":"564fa99c","contact":"676037a0","create-hotel":"a419f35e","dashboard":"c1e633a0","facts":"20de123a","login":"6d7db22f","press":"c4ad8697","privacy":"8f2c4970","test":"40929a62","user-profile":"5cf3438a","chunk-9e3e834c":"c01a8035","chunk-1e068ef0":"d513fe28","chunk-595e8de4":"8cb537a8","chunk-785ca0dc":"3f7e2368","chunk-f76831c2":"a8839452","chunk-2d0cf902":"31d6cfe0","chunk-2530a241":"69e0cdbd","chunk-2a82d251":"0786bbfe","chunk-5514ccb5":"243f0bca","chunk-68a27c44":"46c8cfcc","chunk-7ff1819d":"02389a85","apexcharts":"31d6cfe0","chunk-2d0b8e18":"31d6cfe0","chunk-3daefc74":"5254b143","chunk-fcc1c934":"10a21112"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
